import {RequestMethod, sendRequest} from "../../../agent";
import {BaseResponse} from "./BaseResponse";

export const BaseDataProviderAgent = {
    send: async <TResult>(method: RequestMethod,
                          endpoint: string,
                          data?: any): Promise<TResult> => {
        const response = await sendRequest(method, endpoint, data);
        const result = response.body as BaseResponse<TResult>;
        if (!result.success)
            throw result.message;
        return result.result as TResult;
    }
}
